<template>
    <div class="root">
        <NavigationBar/>

      <div class="content">
        <div class="row" style="height: 100%;">
            <div class="col-12 col-md-6">
                <div class="card_description ">
                <h4>Tangerine™ Store Credit Card</h4>

<h5>Adventure now, pay later.</h5>
<p>
The Tangerine™ Credit Card is your key to exclusive rewards, flexible financing, and members-only perks—designed for those who live life off the beaten path.
</p>
<h5>
Card Benefits:
</h5>
<ul>
    <li>
5X Points on every Crystal Bay purchase—gear, apparel, and travel essentials.
</li>
<li>
0% Intro APR for the first 12 months on purchases over $250.
</li>
<li>
Adventure Credit – Get a $50 reward certificate for every 5,000 points earned.
</li>
<li>
Exclusive Cardholder Events – Early access to seasonal collections and members-only sales.
</li>
<li>
Trailblazer Status – Spend $1,500+ annually to unlock premium perks like free shipping and gifts.
</li>
</ul>
<p>
No annual fee. No limits on your next journey.

Apply in-store or online today and receive a 15% welcome discount on your first purchase with the card!

Issued by Summit Bank, Member FDSA. Subject to credit approval. Terms and conditions apply.


</p>
</div>
            </div>
            <div class="col-12 col-md-6" style=" display: flex;justify-content: center; align-items: center;">
                <img class = "credit_img" src="../assets/credit-card.jpg">
            </div>
        </div>
        </div>
    <FooterView/>
        </div>
</template>
<script>
import NavigationBar from '@/components/NavigationBar.vue';
import FooterView from '@/components/Footer.vue';
export default{
    name: 'ElectronicsScreen',
  components: {
    NavigationBar,
    FooterView
  },
  data(){
}
}

</script>
<style>
.root{
  display: flex;
  flex-direction: column;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
  flex: 1; /* takes all available space */
}
.card_description{
    text-align: start !important;
    margin: 10px;
}
.credit_img{
    border-radius: 100%;
    width: 300px;
    height: 300px;
}
</style>